import React from 'react';

export const MixpanelContext = React.createContext();
